import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { PLATFORM_ID } from "@angular/core";
import { UtilitySerice } from "../shared/services/utility.service";

export const loginGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const utilityService = inject(UtilitySerice);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (utilityService.getAuthToken()) {
    return router.createUrlTree(['/']);
  }

  return true;
};